import { CUSTOM_RV_TYPE_SORT_POST, CUSTOM_RV_TYPE_SORT_PREV, RANGE_FILTER_SECTIONS } from '@/constants/inventory';
import { FilterSection, ISectionOption } from '@/types/inventory';

export type ExtendedSectionOption = ISectionOption | { label: string; isTag: true };

const extrasSectionsToNotSort = new Set<string>([FilterSection.SLIDEOUTS]);

/**
 * Combines regular options and tag options, sorts them alphabetically,
 * with special handling for RV_TYPE section
 */
export const getCombinedAndSortedOptions = (
  section: string,
  options: ISectionOption[],
  tagOptions: string[],
): ExtendedSectionOption[] => {
  // Convert tag options to objects with isTag flag
  const tagOptionsConverted: ExtendedSectionOption[] = tagOptions.map((tag) => ({
    label: tag,
    isTag: true,
  }));

  // Special case: RV_TYPE has custom sorting with tag options in the middle
  if (section === FilterSection.RV_TYPE) {
    return [...CUSTOM_RV_TYPE_SORT_PREV, ...tagOptionsConverted, ...CUSTOM_RV_TYPE_SORT_POST];
  }

  // Combine all options
  const combinedOptions: ExtendedSectionOption[] = [...options, ...tagOptionsConverted];

  if (extrasSectionsToNotSort.has(section) || RANGE_FILTER_SECTIONS.has(section as FilterSection)) {
    return combinedOptions;
  }

  // Sort alphabetically by label (for objects) or value (for strings)
  const sortedOptions = combinedOptions.sort((a, b) => {
    const labelA = typeof a === 'string' ? a : a.label;
    const labelB = typeof b === 'string' ? b : b.label;
    return labelA.localeCompare(labelB);
  });

  return sortedOptions;
};
